import { cx, useAppVariant } from "@jugl-web/utils";
import { useAnimatedCount } from "@jugl-web/utils/hooks/useAnimatedCount";
import { FC, SVGProps, useCallback } from "react";

interface KPICardProps {
  id: string;
  Icon: FC<SVGProps<SVGSVGElement>>;
  label: string;
  value: number;
  className?: string;
}

const animatedMap = new Map<string, boolean>();

export const KPICard: FC<KPICardProps> = ({
  id,
  Icon,
  label,
  value,
  className,
}) => {
  const { isMobile } = useAppVariant();
  const handleComplete = useCallback(() => {
    animatedMap.set(id, true);
  }, [id]);

  const animatedValue = useAnimatedCount({
    targetValue: value,
    isDisabled: animatedMap.get(id) ?? false,
    onComplete: handleComplete,
  });

  if (isMobile)
    return (
      <div
        className={cx(
          "border-grey-300 flex h-[68px] items-center gap-2 rounded-xl border border-solid px-5",
          className
        )}
      >
        <Icon className="h-5 w-5 shrink-0" />
        <span className="text-dark font-secondary ml-0.5 text-xl font-semibold">
          {animatedValue}
        </span>
        <span className="text-dark-800 font-secondary text-xs">{label}</span>
      </div>
    );

  return (
    <div
      className={cx(
        "hover:border-grey-300 hover:ring-grey-300 flex flex-1 flex-col gap-3 rounded-xl border border-solid border-[#DEDEE4] bg-white p-5 ring-inset transition-all hover:ring-1",
        className
      )}
    >
      <div className="flex items-center gap-2">
        <Icon className="h-5 w-5 shrink-0" />
        <span className="font-secondary text-sm font-medium text-[#40494D]">
          {label}
        </span>
      </div>
      <span className="font-secondary text-[32px] font-semibold leading-[1.4] text-[#1A2023]">
        {animatedValue}
      </span>
    </div>
  );
};
